import React from 'react';
import Navbar from './Navbar';
function Header() {
    return (
        <div className='header'>
          <Navbar/>  
          <div className='intro'>
            <p>Constructing home has never been this simple</p>
            <h1><span>Buy </span>and <span>Sell </span>Properties!</h1>
            <p className='details'>&nbsp;&nbsp;We construct homes and ensure peace of mind you deserve with our project tracking service. KNS Contracts Pvt. Limited is a construction company in bengaluru doing house construction, building construction, &amp; commercial construction. <p> House construction packages starts @ *<span>Rs 1580</span>/sft.</p></p>
            <p className='details2'>We sell ready to occupy Flats & Houses, along with other services as demand!</p>
            <a href="#" className='header-btn'>Details&nbsp;&#9656;</a>
            
          </div>
        </div>
    );
}

export default Header;
